<template>
    <Paper>
        <span class="page-description">条码盘点导入</span>
        <i class="page-description-question el-icon-question" :data-title="pageDescription"></i>
        <div class="checkImport">
            <el-row>
                <el-col :span="19">
                    <el-row>
                        <!-- <el-col class="checkSearch-tiem">
                            <el-select v-model="searchData.entityId" placeholder="主体">
                                <el-option v-for="val in entityIdList" :key="val.code" :label="val.name" :value="val.code">
                                </el-option>
                            </el-select>
                        </el-col> -->

                        <el-col class="checkSearch-tiem">
                            <!--   -->
                            <el-input ref="inputCheck" :disabled="inputCheckDisable" v-model="searchData['uploadBy']" placeholder="上传人">
                            </el-input>
                        </el-col>
                        <el-col class="checkSearch-tiem">
                            <el-date-picker value-format='yyyy-MM-dd' v-model="searchData['uploadTime']" type="date" placeholder="选择日期">
                            </el-date-picker>
                        </el-col>

                    </el-row>
                </el-col>
                <el-col :span="5">
                    <div class="checkImport-btns">
                        <el-button class="page-description-upload" type="primary" :loading="searchLoading" size="mini" @click="queryBtClick">
                            {{$translate('lang.E3202207280023', { defaultText: '查 询' })}}
                        </el-button>
                        <!-- <el-button class="page-description-upload" type="primary" :loading="uploadLoading" size="mini" @click="uploadFile">
                            {{$translate('lang.E3202102220002', { defaultText: '上 传' })}}
                        </el-button> -->
                        <el-button class="sn-search-reset-button" @click="restSearchChange" size="mini">{{$translate('lang.E3202207280033', { defaultText: '重 置' })}}</el-button>
                    </div>
                </el-col>
            </el-row>
        </div>
        <div class="btnList">
            <mExport :url='templateExport.exportUrl' :params='templateExport.exportParams' :name='templateExport.exportName' :type='templateExport.type' :listData='listData'
                :exportFlag='templateExport.exportFlag' :titleText='templateExport.titleText'>
            </mExport>
            <el-upload class="upload-demo" ref="upload" action="" :file-list="fileList" :auto-upload="false" :on-remove="handleRemove" :on-change="fileChange">
                <el-button :loading="exportLoading" size="mini" type="primary">{{$translate('lang.E3202207280043', { defaultText: '导入上传' })}}</el-button>
            </el-upload>
        </div>
        <div class="closeStyle">
            <m-table ref="RegistrationTable" :pageTotal="pageTotal" :tableData="listData" :currentPage='currentPage' @pageChange="pageChange" @sizeChange="sizeChange" :config="tableConfig">
            </m-table>
        </div>
    </Paper>
</template>
<script>
import formatTime from '@/utils/common.js';
import Paper from '@/components/core/paper/Paper';
import mExport from '../component/export';
import mTable from '../../../components/IdentityComponent/Main';
import { tableConfig } from './tableConfig.js';
import { dictWithUrl } from '../../../components/basicDataDialog/api';
import { bcBarcodeupload, bcBarcodelist, bcBarcodeCheck, barCodeFileInfoQuery } from '../../../api/lcbsManagement.js';
import { getDictionaryDetail } from '../../../api/systemManagementApi.js';
import store from '@/store/index';
// 家用空调
const ENTITYID = 10;
export default {
    name: 'checkImport',
    components: {
        Paper,
        mExport,
        mTable
    },
    data() {
        return {
            exportLoading: false,
            inputCheckDisable: false,
            templateExport: {
                exportUrl: '/api-sn/lbcs/bcBarcodeCheck/template/download',
                type: 'get',
                exportName: this.$translate('lang.E3202102220004', { defaultText: '条码盘点导入模板.xls' }),
                exportParams: {},
                titleText: this.$translate('lang.E3202102220005', { defaultText: '导出模板' }),
                exportFlag: 1
            },
            uploadLoading: false,
            listData: [],
            fileList: [],
            pageTotal: 0,
            currentPage: 1,
            tableConfig,
            searchData: {},
            templateFlie: {},
            batchId: '',
            pageDescription: '',
            entityIdList: [],
            searchLoading: false,
            timeHorizon: [],
            pickerOptions: {
                shortcuts: [
                    {
                        text: this.$translate('lang.E3202101270017', { defaultText: '最近一周' }),
                        onClick(picker) {
                            picker.$emit('pick', [formatTime.initStartDate(6), formatTime.initEndDate()]);
                        }
                    },
                    {
                        text: this.$translate('lang.E3202101270019', { defaultText: '最近一个月' }),
                        onClick(picker) {
                            picker.$emit('pick', [formatTime.initStartDate(30), formatTime.initEndDate()]);
                        }
                    },
                    {
                        text: this.$translate('lang.E3202101270021', { defaultText: '最近三个月' }),
                        onClick(picker) {
                            picker.$emit('pick', [formatTime.initStartDate(90), formatTime.initEndDate()]);
                        }
                    }
                ]
            },
            dialogVisible: false
        };
    },
    async created() {
        await this.dictData();
    },
    mounted() {
        this.initData();
        // this.checkUserPermission();
    },
    methods: {
        queryBtClick() {
            this.pageChange(1);
        },
        showDialog() {
            this.dialogVisible = true;
        },
        handleClose() {
            this.dialogVisible = false;
            this.templateFlie = {};
            this.listExport.exportFlag = 0;
            this.$refs.upload.clearFiles();
        },
        checkUserPermission() {
            const params = {
                dictCode: 'USER_ROLE',
                pageNo: 1,
                pageSize: 1000
            };

            getDictionaryDetail(params).then(res => {
                if (res.code === '0') {
                    const userCode = store.getters.user.userCode;
                    const userExist = res.data.list.filter((item) => {
                        return item.code === userCode && item.enableFlag === 1;
                    });
                    if (userExist.length > 0) {
                        this.inputCheckDisable = true;
                        this.searchData['uploadBy'] = userExist[0].code;
                    }
                }
            });
        },
        queryData() {
            const params = {
                pageNo: this.tableConfig.page.pageNo,
                pageSize: this.tableConfig.page.pageSize,
                ...this.searchData
            };
            barCodeFileInfoQuery(params).then(res => {
                if (res.code === '0') {
                    this.listData = res.data.list;
                    this.pageTotal = res.data.totalCount;
                }
            });
        },
        initData() {
            this.searchData = {
                entityName: '',
                uploadTime: '',
                uploadBy: ''
            };
            this.templateFlie = {};
            this.fileList = [];
            this.pageTotal = 0;
            this.currentPage = 1;
            this.listData = [];
            this.checkUserPermission();
        },
        handleSearchData() {
            const form = new FormData();
            form.append('file', this.templateFlie.raw);
            // form.append('entityId', this.searchData.entityId);
            form.append('entityId', ENTITYID);
            return form;
        },
        getBatchId(params) {
            // if (params.get('entityId') === 'undefined' || params.get('entityId') === '' || params.get('file') === 'undefined' || params.get('file') === '') {
            //     this.$message.warning(this.$translate('lang.EXC202002220001', { defaultText: '主体、条码上传文件都不能为空！' }));
            //     this.listData = [];
            //     return;
            // };
            if (params.get('file') === 'undefined' || params.get('file') === '') {
                this.$message.warning(this.$translate('lang.EXC202002220001', { defaultText: '条码上传文件都不能为空！' }));
                this.listData = [];
                return;
            };
            this.uploadLoading = true;
            this.exportLoading = true;
            bcBarcodeupload(params).then(res => {
                if (res.code === '0') {
                    this.batchId = res.data;
                    this.$message.success(this.$translate('lang.WARN202207210001', { defaultText: '请稍后到“条码盘点导入查询”界面查看结果' }));
                    // this.getList();
                    // this.checkBatchId();
                    // this.queryData();
                }
            }).finally(() => {
                this.uploadLoading = false;
                this.exportLoading = false;
            });
        },
        getList() {
            if (!this.batchId) {
                this.$message.warning(this.$translate('lang.EXC202002220002', { defaultText: '请先上传条码盘点获取批次号' }));
                return;
            }
            const params = {
                pageNo: this.tableConfig.page.pageNo,
                pageSize: this.tableConfig.page.pageSize,
                batchId: this.batchId
            };
            bcBarcodelist(params).then(res => {
                if (res.code === '0') {
                    this.listData = res.data.list;
                    this.pageTotal = res.data.totalCount;
                }
            });
        },
        checkBatchId() {
            if (!this.batchId) {
                this.$message.warning(this.$translate('lang.EXC202002220002', { defaultText: '请先上传条码盘点获取批次号' }));
                return;
            }
            const params = {
                batchId: this.batchId,
                entityId: this.searchData.entityId
            };
            bcBarcodeCheck(params).then(res => {
                if (res.code === '0') {
                    this.$message.success(this.batchId + this.$translate('lang.EXC202002220004', { defaultText: '批次号盘点成功' }));
                }
            });
        },
        uploadFile() {
            const params = this.handleSearchData();
            this.getBatchId(params);
        },
        restSearchChange() {
            this.initData();
        },
        handleRemove(file) {
            this.templateFlie = {};
            this.fileList = [];
            this.$refs.upload.clearFiles();
        },
        fileChange(file, fileList) {
            if (this.exportLoading) {
                return;
            }
            if (fileList) {
                this.fileList = [fileList[fileList.length - 1]];
            }
            const testmsg = file.name.substring(file.name.lastIndexOf('.') + 1);
            if (testmsg !== 'xls' && testmsg !== 'xlsx') {
                this.$message.warning(this.$translate('lang.EXC202002220005', { defaultText: '表格上传类型不正确,请上传xls,xlsx文件' }));
                this.$refs.upload.clearFiles();
                this.templateFlie = {};
                this.fileList = [];
            } else {
                this.templateFlie = file;
                this.uploadFile();
            }
        },
        pageChange(pageNo) {
            this.tableConfig.page.pageNo = pageNo;
            this.currentPage = pageNo;
            // this.getList();
            this.queryData();
        },
        sizeChange(pageSize) {
            this.tableConfig.page.pageNo = 1;
            this.tableConfig.currentPage = 1;
            this.tableConfig.page.pageSize = pageSize;
            // this.getList();
            this.queryData();
        },
        async dictData() {
            const option = await dictWithUrl('BILL_DESC,BCPARSING_ENTITY_ID');// BILL_DESC-菜单描述
            const dictOptions = {};
            if (+option.code === 0) {
                const dictList = option.data.BILL_DESC;
                this.entityIdList = option.data.BCPARSING_ENTITY_ID;
                dictList.forEach(item => {
                    dictOptions[item.code] = item.name;
                });
            }
            this.pageDescription = dictOptions[this.$options.name].replace(/ {2}/g, '\n');
        }
    }
};
</script>
<style lang="less" src='./index.less'>
</style>
